import { RiskLevel } from "./risk-level";
import { EvaluatorResult } from "./evaluator-result";
import { ResultInfo } from "./shared.model";


export class RiskAssessment {
  level: RiskLevel;
  private analysisResults: EvaluatorResult[] = [];

  constructor(level: RiskLevel) {
    this.level = level;
  }

  public getAnalysisResults(): EvaluatorResult[] {
    return [...this.analysisResults];
  }

  public addAnalysisResult(result: EvaluatorResult): void {
    this.analysisResults.push(result);
  }

  public getAnalysisResultListByName(name: string): EvaluatorResult[] {
    return [...this.analysisResults].filter(value => value.name == name);
  }

  public getAnalysisResultByName(name: string): EvaluatorResult {
    return [...this.analysisResults].find(value => value.name == name);
  }

  public updateAnalysisResultInfoEntry(evaluatorType: string, info: ResultInfo, filterKey?: string, filterValue?: any): void {
    let analysisResults = this.getAnalysisResultListByName(evaluatorType);

    if (analysisResults.length > 1 && filterKey && filterValue)
      analysisResults = analysisResults.filter(value => value.additionalInfo[filterKey] == filterValue);

    analysisResults.forEach(result => {
      Object.assign(result.additionalInfo, info);
    });
  }
}
